import { useEffect, useMemo, useState } from 'react';
import { useIsMounted } from 'seagull';
import { useStateInRef } from 'seagull/utils/useStateInRef';
import { useIoContext } from '~/contexts';
import { retryCountdownSeconds } from '~/utils/networkRetry/network-retry-schedule';
export function useNetworkRetry(param) {
    let { active, attempt, schedule } = param;
    const { browser } = useIoContext();
    const [failedAttempts, setFailedAttempts] = useState(0);
    const [isRetrying, setIsRetrying] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(()=>retryCountdownSeconds(0, schedule.random(), schedule));
    const flight = useMemo(()=>({
            pending: null
        }), []);
    const isMounted = useIsMounted();
    const getRunAttempt = useStateInRef(runAttempt);
    useEffect(()=>{
        if (active && !isRetrying) {
            const countdown = {
                remaining: retryCountdownSeconds(failedAttempts, schedule.random(), schedule)
            };
            setSecondsLeft(countdown.remaining);
            const stopTicker = schedule.startTicker(()=>{
                countdown.remaining -= 1;
                setSecondsLeft(countdown.remaining);
                if (countdown.remaining <= 0) {
                    stopTicker();
                    void getRunAttempt()('scheduled');
                }
            });
            return stopTicker;
        }
    }, [
        active,
        isRetrying,
        failedAttempts,
        schedule
    ]);
    useEffect(()=>{
        if (active) {
            return browser.registerOnlineListener(()=>void getRunAttempt()('online_hint'));
        }
    }, [
        active
    ]);
    function runAttempt(trigger) {
        if (!flight.pending) {
            flight.pending = attemptAndSettle(trigger);
        }
        return flight.pending;
    }
    async function attemptAndSettle(trigger) {
        setIsRetrying(true);
        await attempt(trigger).catch(()=>{});
        flight.pending = null;
        if (isMounted()) {
            setFailedAttempts((count)=>trigger === 'scheduled' ? count + 1 : 0);
            setIsRetrying(false);
        }
    }
    function retryNow() {
        let trigger = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'manual';
        return getRunAttempt()(trigger);
    }
    return {
        isActive: active,
        isRetrying,
        secondsLeft,
        retryNow
    };
}
